import React from 'react';
import Flex from '../../../atoms/Box/Flex';
import FlagIcon from '../../../atoms/FlagIcon/FlagIcon';
import { countries } from '../../../../services/helpers/country';

/** Countries a merchant can be added in: the ones with an organization number format hint (see ValidationTypes). */
export const supportedMerchantCountryCodes = ['SE', 'NO', 'FI', 'DK'];

export const merchantCountryOptions = supportedMerchantCountryCodes.map(code => ({
    value: code,
    label: (
        <Flex gap="1rem" alignItems="center">
            <FlagIcon countryCode={code} /> {countries[code].name}
        </Flex>
    ),
}));
